export default __webpack_public_path__ + "locales/sq-AL/OAuth.json?hash=30b9b28e27385d7319c488f1649d0b55";